import { Reducer } from "redux";
import * as venueActions from "./venueActions";
import { VenueListItem } from "../../model/VenueListItem";
import { Venue } from "../../model/Venue";
import { AdminErrorListResponseData } from "../../service/api-response/AdminFormErrorResponse";
import _ from "lodash";
import produce from "immer";

interface VenueStateOrganizationRecord {
  isLoadingVenues: boolean;
  isLoadingVenue: boolean;
  isUpsertingVenue: boolean;
  venues: VenueListItem[];
  filters: {
    title?: string;
    isDisabled?: boolean;
    tag?: string;
    filterByCountry?: string;
  };
  venueTitlesForSearch: string[];
  venueToEdit: Venue | undefined;
  errors: AdminErrorListResponseData | undefined;
  isDeletingVenueImage: Record<string, boolean>;
  // lastInsertedId: undefined;
}
export interface VenueState {
  org: {
    [org: string]: VenueStateOrganizationRecord;
  };
}

const initialState: VenueState = {
  org: {},
};

type SupportedActions =
  | venueActions.GetVenueForEditAction
  | venueActions.GetVenueForEditSuccessAction
  | venueActions.GetVenueForEditFailAction
  | venueActions.InsertVenueAction
  | venueActions.InsertVenueFailAction
  | venueActions.InsertVenueSuccessAction
  | venueActions.UpdateVenueAction
  | venueActions.UpdateVenueFailAction
  | venueActions.UpdateVenueSuccessAction
  | venueActions.DeleteVenueImageAction
  | venueActions.DeleteVenueImageSuccessAction
  | venueActions.DeleteVenueImageFailAction;
// | LocationChangeAction;

const initialVenueStateOrganizationRecord = (): VenueStateOrganizationRecord => {
  return {
    isLoadingVenues: false,
    isLoadingVenue: false,
    isUpsertingVenue: false,
    venues: [],
    filters: {},
    venueTitlesForSearch: [],
    venueToEdit: undefined,
    errors: undefined,
    isDeletingVenueImage: {},
    // lastInsertedId: undefined,
  };
};

export const venueReducer: Reducer<VenueState, SupportedActions> = (
  state = initialState,
  action
): VenueState =>
  produce(state, (draftState) => {
    if (
      action["organization"] &&
      _.isString(action["organization"]) &&
      !draftState.org[action["organization"]]
    ) {
      draftState.org[
        action["organization"]
      ] = initialVenueStateOrganizationRecord();
    }
    const draftOrgState = draftState.org[
      action["organization"]
    ] as VenueStateOrganizationRecord;

    switch (action.type) {
      case venueActions.INSERT_VENUE: {
        draftOrgState.errors = undefined;
        draftOrgState.isUpsertingVenue = true;
        break;
      }
      case venueActions.INSERT_VENUE_FAIL: {
        draftOrgState.isUpsertingVenue = false;
        if (action.errors?.length) {
          draftOrgState.errors = action.errors;
        }
        break;
      }
      case venueActions.INSERT_VENUE_SUCCESS: {
        draftOrgState.errors = undefined;
        draftOrgState.venueToEdit = undefined;
        draftOrgState.isUpsertingVenue = false;
        // draftOrgState.lastInsertedId = action.newVenueId;
        break;
      }
      case venueActions.UPDATE_VENUE: {
        draftOrgState.errors = undefined;
        draftOrgState.isUpsertingVenue = true;
        break;
      }
      case venueActions.UPDATE_VENUE_FAIL: {
        draftOrgState.isUpsertingVenue = false;

        if (action.errors && action.errors.length) {
          draftOrgState.errors = action.errors;
        }

        break;
      }
      case venueActions.UPDATE_VENUE_SUCCESS: {
        draftOrgState.errors = undefined;
        draftOrgState.venueToEdit = undefined;
        draftOrgState.isUpsertingVenue = false;

        break;
      }
      case venueActions.GET_VENUE_FOR_EDIT: {
        draftOrgState.isLoadingVenue = true;
        break;
      }
      case venueActions.GET_VENUE_FOR_EDIT_SUCCESS: {
        draftOrgState.venueToEdit = action.venue;
        draftOrgState.isLoadingVenue = false;
        break;
      }
      case venueActions.GET_VENUE_FOR_EDIT_FAIL: {
        draftOrgState.isLoadingVenue = false;
        break;
      }
      case venueActions.DELETE_VENUE_IMAGE: {
        draftOrgState.isDeletingVenueImage[action.imageUrl] = true;
        break;
      }
      case venueActions.DELETE_VENUE_IMAGE_FAIL: {
        draftOrgState.isDeletingVenueImage[action.imageUrl] = false;
        break;
      }
      case venueActions.DELETE_VENUE_IMAGE_SUCCESS: {
        draftOrgState.isDeletingVenueImage[action.imageUrl] = false;
        if (
          draftOrgState.venueToEdit &&
          _.isArray(draftOrgState.venueToEdit.images)
        ) {
          draftOrgState.venueToEdit.images = draftOrgState.venueToEdit?.images.filter(
            (x) => x.url !== action.imageUrl
          );
        }
        break;
      }
    }
  });
